import { useInfiniteQuery } from '@tanstack/react-query';
import { changeHistoryViewerApi } from '../api/changeHistoryViewerApi';

const PAGE_SIZE = 20;

/**
 * GET /change-history-viewer/entities — 추적 엔티티 목록 (커서 무한 스크롤)
 * queryKey: ['change-history-viewer', 'entities', filters]
 */
export function useTrackedEntities(filters: { keyword?: string; status?: string }) {
  return useInfiniteQuery({
    queryKey: ['change-history-viewer', 'entities', filters] as const,
    queryFn: ({ pageParam }) =>
      changeHistoryViewerApi.listEntities({
        keyword: filters.keyword || undefined,
        status: filters.status || undefined,
        cursor: (pageParam as string | undefined) ?? undefined,
        size: PAGE_SIZE,
      }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) =>
      lastPage.hasMore ? (lastPage.nextCursor ?? undefined) : undefined,
    staleTime: 30_000,
  });
}
